import { createSlice } from "@reduxjs/toolkit";
import { convertArrayToObject } from "../../helpers/catalog-helper";
import {cloneDeep} from "lodash";
export interface ChannelMenuState {
  isFetchingData: boolean,
  isExportReport: boolean;
  channelMenuCategoriesList: any;
  channelMenuItemsMap: any;
  channelMenuItemsList: any;
  tempState: any;
  displayBookData: {};
  curerntDisplayBookId: string
}

const initialState: ChannelMenuState = {
  isFetchingData: false,
  isExportReport: false,
  channelMenuCategoriesList: [],
  channelMenuItemsMap: {},
  channelMenuItemsList: [],
  tempState: {},
  displayBookData: {},
  curerntDisplayBookId: ""
}

function flat(catList: any) {
  let result: any = [];
  catList.forEach(function (element: any) {
    if(element.items) {
      result.push(...element.items);
    }
    if (Array.isArray(element.subCategories)) {
      result = result.concat(flat(element.subCategories));
    }
  });
  return result;
}

export const channelMenu = createSlice({
  name: 'business',
  initialState,
  reducers: {
    getAllDisplayBooks: (state) => {},
    saveDisplayBookData: (state, actions) => {
      state.displayBookData = convertArrayToObject(actions.payload);
    },
    deleteDisplayBook: (state, actions) => {},
    updateDisplayBookInReducer: (state, actions) => {
      const newDisplayBookData: any = cloneDeep(state.displayBookData);
      newDisplayBookData[actions.payload.mid] = actions.payload;
      state.displayBookData = newDisplayBookData;
    },
    getChannelMenuCategories: (state, actions) => {
      state.isFetchingData = true;
    },
    saveChannelMenuCategories: (state, actions) => {
      const menuItemsList = flat(actions.payload.items);
      state.curerntDisplayBookId = actions.payload.displayBookId;
      state.channelMenuCategoriesList = actions.payload.items;
      state.channelMenuItemsList = menuItemsList;
      state.channelMenuItemsMap = convertArrayToObject(menuItemsList, "itemId"); //creating channel Menu item map
      state.isFetchingData = false;
    },
    getMenuItemData: (state, action) => {
      state.isFetchingData = true;
    },
    saveMenuItemData: (state, actions) => {
      state.channelMenuItemsMap[actions.payload.mid] = actions.payload;
      state.isFetchingData = false;
    },
    createOrUpdateDisplayBook: (state, actions) => {},
    updateChannelMenu: (state, actions) => {}
  }
})

export const {
  getChannelMenuCategories,
  saveChannelMenuCategories,
  getAllDisplayBooks,
  deleteDisplayBook,
  saveDisplayBookData,
  createOrUpdateDisplayBook,
  updateChannelMenu,
  updateDisplayBookInReducer
} = channelMenu.actions;
export default channelMenu.reducer;